const SCOPES = {
  __SELF__: "__SELF__", // Scope to skip checks for user's self routes like settings
  LOGS: "logs",
  LISTS: "lists",
  BILLING_CYCLES: "billing_cycles",
  CATEGORIES: "categories",
  CERTIFICATIONS: "certifications",
  CONTENT: "content",
  BUYERS: "buyers",
  CONTENT_TYPES: "content_types",
  COUNTRIES: "countries",
  MOVIES: "movies",
  CPL_MAPPINGS: "cpl_mappings",
  NOTIFICATION_TEMPLATES: "notification_templates",
  CAMPAIGN_TARGET_TYPE: "campaign_target_types",
  BRANDS: "brands",
  BRAND_VERIFICATIONS: "brand_verifications",
  HOLIDAYS: "holidays",
  PLAYLIST_PACK_TYPES: "playlist_pack_types",
  PLAYLIST_TEMPLATES: "playlist_templates",
  REASONS: "reasons",
  RIGHTS: "rights",
  SEGMENT_TYPES: "segment_types",
  ADVERTISER_TYPES: "buyer_types",
  TIMES_OF_DAY: "times_of_day",
  THEATRE_TYPES: "theatre_types",
  THEATRE_LOCATION_TYPES: "theatre_location_types",
  DIGITAL_INTEGRATORS: "digital_integrators",
  PROJECTION_TYPES: "projection_types",
  COOLING_TYPES: "cooling_types",
  EXPERIENCES: "experiences",
  TAGS: "tags",
  SCOPES: "scopes",
  USERS: "users",
  PRODUCT_IDENTIFICATION_NUMBER_TYPES: "product_identification_number_types",
  SETUP: "setup",
  RATE_CARDS: "rate_cards",
  CAMPAIGNS: "campaigns",
  TARGET_GROUPS: "target_groups",
  MEDIA: "media",
  COMPOSITIONS: "cpls",
  SCHEDULES: "schedules",
  INVENTORY: "inventory",
  COMPANIES: "companies",
  COMPANIES_PREFERENCES: "companies_preferences",
  COMPANIES_MANAGE: "companies_manage",
  USER_PREFERENCES: "user_preferences",
  REPORTS: "reports",
  CAMPAIGN_BIAS: "campaign_bias",
};

const SCOPE_ACTIONS = {
  READ: "READ",
  WRITE: "WRITE",
  DELETE: "DELETE",
  APPROVE: "APPROVE",
  MERGE: "MERGE",
  UPLOAD: "UPLOAD",
  DOWNLOAD: "DOWNLOAD",
  ASSIGN: "ASSIGN",
  TRANSFER: "TRANSFER",
  MAP: "MAP",
  IGNORE: "IGNORE",
};

export { SCOPES, SCOPE_ACTIONS };
